import { useEffect, useRef } from 'react';

import { MetricsTracker, USER_EVENTS } from '@sm/metrics';

export type EndPageViewParams = {
  countryCode: string;
  countryRegion: string;
  pageName: string;
  templateType: string;
  surveyId?: string;
  collectorId?: string;
  respondentId?: string;
  languageId?: string;
};

const useEndPageView = (params: EndPageViewParams): void => {
  const hasFired = useRef(false);

  // useEffect has the the... effect of ensuring we only fire in the browser
  useEffect(() => {
    if (!hasFired.current) {
      const { countryCode, countryRegion, pageName, templateType, surveyId, collectorId, respondentId, languageId } =
        params;

      // we'll tailor two different tracking events for their respective
      // subscribers so that we don't end up with amplitude data in the splunk logs
      // pool and vice verse. this is done through the use of what properties
      // we send. Amplitude will only send when there's an `amplitudeEvent` prop.
      // Splunk logging will only send when there's `log`. By eliminating the
      // `actionType`/`actionFlow` properties, we'll leave the BI page view to
      // BasePage/SurveyBasePage

      // Amplitude page viewed event
      MetricsTracker.track({
        name: USER_EVENTS.PAGE_VIEW,
        data: {
          amplitudeEvent: 'page viewed',
          pageName,
          templateType,
          surveyId,
          collectorId,
          respondentId,
          urlPath: window.location.pathname,
          app: 'respweb',
        },
      });

      // Logging
      MetricsTracker.track({
        name: USER_EVENTS.PAGE_VIEW,
        data: {
          log: {
            message: templateType,
            countryCode,
            countryRegion,
            languageId: languageId ?? 'none',
          },
        },
      });

      // we're done. never do this again
      hasFired.current = true;
    }
  }, [params, hasFired]);
};

export default useEndPageView;
